const PHRASES = [
    "Debate",
    "Diplomacy",
    "Democracy",
    "Dialogue",
    "I-ACE Chapter 4",
];

const Row = () => (
    <div className="flex shrink-0 items-center">
        {PHRASES.map((p, i) => (
            <span key={i} className="flex items-center">
                <span
                    className={`whitespace-nowrap px-8 font-serif text-4xl font-light md:px-14 md:text-6xl ${
                        p === "I-ACE Chapter 4"
                            ? "italic text-scarlet"
                            : "text-cream/15"
                    }`}
                >
                    {p}
                </span>
                <span className="h-1.5 w-1.5 rounded-full bg-crimson/50" aria-hidden="true" />
            </span>
        ))}
    </div>
);

const Marquee = () => (
    <div
        data-testid="editorial-marquee"
        aria-hidden="true"
        className="relative overflow-hidden border-y border-cream/5 bg-coal/60 py-8 md:py-10"
    >
        <div className="animate-marquee flex w-max">
            <Row />
            <Row />
        </div>
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-ink to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-ink to-transparent" />
    </div>
);

export default Marquee;
